module.exports = __webpack_public_path__ + "img/ai_help01_icon_03.0b28e0fe.png";